module.exports = __webpack_public_path__ + "img/customer_design_10.86bf1a0.jpg";